import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import CustomSelect from './CustomSelect.component';
import Select from 'react-select';

export default function ServicesSelect(props) {
  
  // Local State
  const [options, setOptions] = useState('');
  // Redux State
  const token = useSelector(state => state.auth.token);


  const colourStyles = {
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      // const color = chroma(data.color);
      // console.log({ data, isDisabled, isFocused, isSelected });
      return {
        ...styles,
        backgroundColor: isFocused || isSelected ? "#0eb2ef" : null,
        color: isFocused || isSelected ? "#fff" : "#000",
      };
    },
  };

  useEffect(() => {
    async function getAllServices(){
      await fetch(`${process.env.REACT_APP_BASE_URL}/api/services`, {
        method: "GET",
        headers: {
          'Accept': 'application/json',
          "Authorization": `Bearer ${token}`
        }
      })
      .then(r => r.json())
      .then(response => {
        if (response.success) {
          let opt = response.records.data.map((item) => {
            return {
              value: item.id,
              label: item.service_name,
              // id: item.id,
            };
          });

          setOptions(opt);

        } else {
          console.log(response);
        }
      })
    }    
    getAllServices();
  }, [token]);

  const selectDefaults = (value) => {
    return options  ? options.find(item => item.value === value) : "";
  }

  return (
    <>       
      <Select
        options={options}
        className={props?.className}
        components={{
          IndicatorSeparator: () => null,
        }}
        styles={colourStyles}
        onChange={props.onChange}
        name={props.name}
        value={selectDefaults(props.value)}
      />
    </>
  )
}
